import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWrapper from './AppWrapper';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import { auth0Config } from './auth0-config';

const authParams = {
  redirect_uri: auth0Config.redirectUri,
  scope: auth0Config.scope,
};

// Only include audience if it's set
if (auth0Config.audience) {
  authParams.audience = auth0Config.audience;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={authParams}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <AppWrapper />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
